<template>
  <div class="history">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Date</th>
            <th>Comments</th>
            <th>Quote File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(quote, index) in rfq.bids" :key="index">
            <td>{{ new Date(quote.sent_on).toLocaleDateString() }}</td>
            <td>{{ quote.comment }}</td>
            <td>
              <a :href="quote.bid_pdf" target="_blank" class="primary--text">{{
                quote.bid_pdf
              }}</a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    rfq: {
      type: Object,
      default: null
    }
  }
};
</script>
